import React from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { Icon } from '@winnin/winnin_ui.components.icon'

import './index.scss'

export default function BreadCrumb({
  link,
  title,
  isLastLevel,
  isClickBlocked,
  className,
  hideArrow = false,
  handleOnClick,
}) {
  const handleClick = e => {
    if (isClickBlocked) {
      e.preventDefault()
      return
    }
    handleOnClick?.(e)
  }

  return (
    <div className="BreadCrumb">
      <Link
        to={link}
        onClick={e => handleClick(e)}
        className={classNames('BreadCrumb-link', className, { 'BreadCrumb-title': isLastLevel })}
      >
        {title}
      </Link>

      {!hideArrow && <Icon icon="arrowRight" fill="#B4B9C0" />}
    </div>
  )
}
